import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/7_card_back_ginger_kitten/7_card_back_ginger_kitten"
 * Contains 1 texture(s)
 */
export class CardsBacks7CardBackGingerKittenAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/7_card_back_ginger_kitten/7_card_back_ginger_kitten';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '7_ginger_kitten.png'
    ] as const;
}
